export default function (item) {
  const link = item.file;
  const fileType = link.split('.').pop().toLocaleLowerCase();

  return fileType === 'mp4' ||
    fileType === 'webm' ||
    fileType === 'ogg';
}
